import React from "react";
import PropTypes from "prop-types";

import powered_by_gametize_image from "images/core/home/powered-by-gametize-white-colored.png";

const propTypes = {
  isTour: PropTypes.bool
};

const defaultProps = {
  isTour: false
};

const LoginPoweredByImageRow = props => (
  <div className={"pure-u-1 flex justify-content-center bottommargin-10"}>
    <div className="home-powered-by-container">
      <a
        href="https://www.gametize.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="imgresponsive" src={powered_by_gametize_image} alt="" />
      </a>
    </div>
  </div>
);

LoginPoweredByImageRow.propTypes = propTypes;
LoginPoweredByImageRow.defaultProps = defaultProps;

export default LoginPoweredByImageRow;
